/* eslint-disable vue/multi-word-component-names */
<template>
  <div class="app-container" @keydown.esc="closeDropdown" tabindex="0">
    <Register v-if="currentPage === 'register'" @go-home="currentPage = 'home'" />

    <template v-else>
      <header class="header">
        <div class="logo">
          <img src="../assets/logo.png" alt="Logo" class="logo-img" />
        </div>

        <nav class="nav">
          <a href="#" class="nav-link" @click.prevent="router.push('/home')">首页</a>

          <a
            href="#"
            class="nav-link nav-link-dropdown"
            :class="{ 'is-open': openDropdown === 'talent' }"
            @click.prevent="toggleDropdown('talent')"
          >
            人才库
          </a>

          <a
            href="#"
            class="nav-link nav-link-dropdown"
            :class="{ 'is-open': openDropdown === 'jobs' }"
            @click.prevent="toggleDropdown('jobs')"
          >
            找工作
          </a>
        </nav>

        <div class="header-actions">
          <span class="action-link" @click="router.push('/publish-task')">发布任务</span>
          <span class="action-link" @click="router.push('/talent')">入驻人才库</span>
          <span class="action-link" @click="router.push('/profile')">个人中心</span>

          <el-button class="register-btn" type="success"  @click="$router.push('/register')">注册</el-button>
        </div>

        <div v-show="openDropdown" class="mega-dropdown">
          <div v-if="openDropdown === 'talent'" class="mega-panel">
            <div class="mega-inner">
              <div class="talent-left1">
                <div class="talent-left-title1">{{ talentMenu.title }}</div>
                <div class="talent-left-list1">
                  <div
                    v-for="cat in talentMenu.leftCategories"
                    :key="cat.key"
                    class="talent-left-item1"
                    :class="{ active: activeTalentCatKey === cat.key }"
                    @click="setTalentCategory(cat.key)"
                  >
                    {{ cat.label }}
                  </div>
                </div>
              </div>

              <div class="talent-right">
                <div class="cols">
                  <div v-for="(col, idx) in talentColumns" :key="'tcol-' + idx" class="col">
                    <div class="col-title">{{ col.title }}</div>
                    <div class="col-items">
                      <div
                        v-for="item in col.items"
                        @click="setTalentSub(item.label)"
                        :key="item.label"
                        class="col-item"
                        :class="{ highlight: item.highlight }"
                      >
                        {{ item.label }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="openDropdown === 'jobs'" class="mega-panel">
            <div class="mega-inner jobs-inner">
              <div class="jobs-left">
                <div class="jobs-left-list">
                  <div
                    v-for="cat in jobsMenu.leftCategories"
                    :key="cat.key"
                    class="jobs-left-item"
                    :class="{ active: activeJobsCatKey === cat.key }"
                    @click="setJobsCategory(cat.key)"
                  >
                    {{ cat.label }}
                  </div>
                </div>
              </div>

              <div class="jobs-right">
                <div class="cols jobs-cols">
                  <div v-for="(col, idx) in jobsColumns" :key="col.key || 'jcol-' + idx" class="col">
                    <div class="col-title">{{ col.title }}</div>
                    <div class="col-items">
                      <div
                        v-for="item in col.items"
                        :key="item.label"
                        class="col-item"
                        :class="{ highlight: item.highlight }"
                        @click="setJobsSub(item.label)"
                      >
                        {{ item.label }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </header>

      <div v-show="openDropdown" class="dropdown-backdrop" @click="closeDropdown"></div>

      <main class="main-content">
        <div class="hero-section">
          <div class="hero-text">
            <h1 class="hero-title">
              Navigating the<br />
              digital landscape<br />
              for success
            </h1>
            <p class="hero-description">
              Our digital marketing agency helps businesses<br />
              grow and succeed online through a range of<br />
              services including SEO, PPC, social media marketing,<br />
              and content creation.
            </p>

            <el-button class="cta-button" type="primary">Book a consultation</el-button>
          </div>
        </div>

        <div class="services-grid">
          <el-card v-for="(s, idx) in services" :key="'svc-' + idx" class="service-card" shadow="never" body-style="padding: 0">
            <img :src="s.icon" :alt="s.name" class="service-icon" />
            <span class="service-name">{{ s.name }}</span>
          </el-card>
        </div>
      </main>

      <section class="about-wrapper">
        <div class="about-section">
          <div class="about-content">
            <h2 class="about-title">关于我们</h2>
            <p class="about-text">
              云链是一个专业的兼职任务匹配平台，致力于通过创新的AI技术连接有需求的企业和自由职业者。我们的使命是让兼职工作更加高效、透明和可靠。
            </p>
            <p class="about-text">
              我们拥有庞大的人才库，涵盖设计、开发、营销、写作等多个领域，为企业提供全方位的人才解决方案。同时，我们也为自由职业者提供丰富的工作机会，帮助他们实现职业价值。
            </p>
          </div>
          <div class="about-logo">
            <video class="about-video" autoplay loop muted playsinline>
              <source src="../assets/gywm.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </section>

      <!-- ✅ 这里改成 div 滑块 -->
      <section class="process-wrapper">
        <div class="process-section">
          <div class="process-switch" role="tablist" aria-label="流程切换">
        
            <div class="switch-pill">
          
              <div
                class="switch-slider"
                :class="{ right: activeTab === 'freelancer' }"
              ></div>
              <button
                class="switch-btn"
                :class="{ active: activeTab === 'employer' }"
                type="button"
                role="tab"
                :aria-selected="activeTab === 'employer'"
                @click="activeTab = 'employer'"
              >
                我想雇人
              </button>
              <button
                class="switch-btn"
                :class="{ active: activeTab === 'freelancer' }"
                type="button"
                role="tab"
                :aria-selected="activeTab === 'freelancer'"
                @click="activeTab = 'freelancer'"
              >
                我想接单
              </button>
            </div>
          </div>

          <div class="process-steps" v-if="activeTab === 'employer'">
            <div class="process-step">
              <div class="step-image">
                <img src="../assets/1 23457.png" alt="永远免费发布工作" />
              </div>
              <h3 class="step-title">永远免费发布工作</h3>
            </div>
            <div class="process-step">
              <div class="step-image">
                <img src="../assets/1 23458.png" alt="挑选全国各地优秀人才" />
              </div>
              <h3 class="step-title">挑选全国各地优秀人才</h3>
            </div>
            <div class="process-step">
              <div class="step-image">
                <img src="../assets/1 23458(1).png" alt="交付成功" />
              </div>
              <h3 class="step-title">交付成功！</h3>
            </div>
          </div>

          <div class="process-steps" v-if="activeTab === 'freelancer'">
            <div class="process-step">
              <div class="step-image">
                <img src="../assets/11 1.png" alt="随时随地灵活办公" />
              </div>
              <h3 class="step-title">随时随地灵活办公</h3>
            </div>
            <div class="process-step">
              <div class="step-image">
                <img src="../assets/11 2.png" alt="劳有所得 结单后立即收款" />
              </div>
              <h3 class="step-title">"劳"有所得 结单后立即收款</h3>
            </div>
            <div class="process-step">
              <div class="step-image">
                <img src="../assets/11 3.png" alt="在工作中成长 以经验度岁月" />
              </div>
              <h3 class="step-title">在工作中成长 以经验度岁月</h3>
            </div>
          </div>
        </div>
      </section>
      <section class="process-wrapper">
        <div class="process-section">
          <div class="process-switch" role="tablist" aria-label="流程切换">
        
            <div class="switch-pill">
          
              <div
                class="switch-slider"
                :class="{ right: activeTab === 'freelancer' }"
              ></div>
              <button
                class="switch-btn"
                :class="{ active: activeTab === 'employer' }"
                type="button"
                role="tab"
                :aria-selected="activeTab === 'employer'"
                @click="activeTab = 'employer'"
              >
                我想雇人
              </button>
              <button
                class="switch-btn"
                :class="{ active: activeTab === 'freelancer' }"
                type="button"
                role="tab"
                :aria-selected="activeTab === 'freelancer'"
                @click="activeTab = 'freelancer1'"
              >
                我想接单
              </button>
            </div>
          </div>

          <div class="process-steps" v-if="activeTab === 'freelancer'">
            <div class="process-step">
              <div class="step-image">
                <img src="../assets/1 23457.png" alt="永远免费发布工作" />
              </div>
              <h3 class="step-title">永远免费发布工作</h3>
            </div>
            <div class="process-step">
              <div class="step-image">
                <img src="../assets/1 23458.png" alt="挑选全国各地优秀人才" />
              </div>
              <h3 class="step-title">挑选全国各地优秀人才</h3>
            </div>
            <div class="process-step">
              <div class="step-image">
                <img src="../assets/1 23458(1).png" alt="交付成功" />
              </div>
              <h3 class="step-title">交付成功！</h3>
            </div>
          </div>

          <div class="process-steps" v-if="activeTab === 'employer'">
            <div class="process-step">
              <div class="step-image">
                <img src="../assets/11 1.png" alt="随时随地灵活办公" />
              </div>
              <h3 class="step-title">随时随地灵活办公</h3>
            </div>
            <div class="process-step">
              <div class="step-image">
                <img src="../assets/11 2.png" alt="劳有所得 结单后立即收款" />
              </div>
              <h3 class="step-title">"劳"有所得 结单后立即收款</h3>
            </div>
            <div class="process-step">
              <div class="step-image">
                <img src="../assets/11 3.png" alt="在工作中成长 以经验度岁月" />
              </div>
              <h3 class="step-title">在工作中成长 以经验度岁月</h3>
            </div>
          </div>
        </div>
      </section>
      <!-- 下面保持不变 -->
      <section class="usage-wrapper">
        <div class="usage-section">
          <h2 class="usage-title">使用流程</h2>
          <p class="usage-description">通过云链，您可以快速组建专业团队，高效完成项目</p>

          <div class="usage-content">
            <div class="usage-left">
              <div class="usage-step active">
                <div class="step-indicator">
                  <span class="step-dot active"></span>
                  <span class="step-label">第一步：甲方发布任务</span>
                </div>
                <el-button class="step-button active" type="success" plain>去发布 &gt;</el-button>
              </div>

              <div class="usage-step">
                <div class="step-indicator">
                  <span class="step-dot"></span>
                  <span class="step-label">第二步：乙方报价</span>
                </div>
                <el-button class="step-button" plain>去发布 &gt;</el-button>
              </div>

              <div class="view-more">
                <span class="view-more-text" @click="$router.push('/slices')">查看完整流程 &gt;</span>
              </div>
            </div>

            <div class="usage-right">
              <img src="../assets/Frame 427320441.png" alt="使用流程预览" class="preview-image" />
            </div>
          </div>
        </div>
      </section>

      <section class="reviews-wrapper">
        <div class="reviews-section">
          <h2 class="reviews-title">用户评价</h2>
          <p class="reviews-description">听听我们的用户如何评价云链平台</p>

          <div class="reviews-container">
            <el-card v-for="(review, index) in staticReviews" :key="'review-' + index" class="review-card" shadow="never" body-style="padding: 0">
              <div class="review-header">
                <span class="review-badge">{{ review.badge }}</span>
              </div>
              <p class="review-text">{{ review.text }}</p>
              <div class="review-footer">
                <div class="reviewer-info">
                  <img src="../assets/txjpeg.jpeg" :alt="review.name" class="reviewer-avatar" />
                  <div class="reviewer-details">
                    <span class="reviewer-name">{{ review.name }}</span>
                    <span class="reviewer-date">{{ review.date }}</span>
                  </div>
                </div>
                <div class="review-rating">
                  <span class="star">★</span>
                  <span class="rating-score">{{ review.rating }}</span>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </section>

      <section class="why-choose-wrapper">
        <div class="why-choose-section">
          <h2 class="why-choose-title">为什么选择云链</h2>
          <p class="why-choose-description">告别传统外包模式，选择最心仪的人才</p>

          <div class="comparison-image">
            <img src="../assets/Snipaste_2026-02-06_03-25-06.png" alt="云链 VS 其他平台对比" class="comparison-img" />
          </div>
        </div>
      </section>

      <footer class="footer">
        <div class="footer-content">
          <div class="footer-top">
            <div class="footer-logo-section">
              <img src="../assets/logo.png" alt="云链 TaskLink" class="footer-logo" />
            </div>
            <el-button class="footer-join-btn" plain>入驻人才库</el-button>
          </div>

          <div class="footer-links">
            <div class="footer-column">
              <h3 class="footer-column-title">首页目录</h3>
              <a href="#" class="footer-link">首页</a>
              <a href="#" class="footer-link">招人才</a>
              <a href="#" class="footer-link">找工作</a>
            </div>

            <div class="footer-column">
              <h3 class="footer-column-title">WEB开发</h3>
              <a href="#" class="footer-link">APP开发</a>
              <a href="#" class="footer-link">软件开发</a>
              <a href="#" class="footer-link">游戏开发</a>
              <a href="#" class="footer-link">AI开发</a>
            </div>

            <div class="footer-column">
              <h3 class="footer-column-title">视频剪辑</h3>
              <a href="#" class="footer-link">UX设计</a>
              <a href="#" class="footer-link">UI设计</a>
              <a href="#" class="footer-link">品牌设计</a>
              <a href="#" class="footer-link">Web设计</a>
            </div>

            <div class="footer-column">
              <h3 class="footer-column-title">文案制作</h3>
              <a href="#" class="footer-link">网站运维</a>
              <a href="#" class="footer-link">翻译</a>
              <a href="#" class="footer-link">品牌管理</a>
              <a href="#" class="footer-link">营销策划</a>
            </div>

            <div class="footer-column">
              <h3 class="footer-column-title">教育辅导</h3>
              <a href="#" class="footer-link">初中教育辅导</a>
              <a href="#" class="footer-link">高中教育辅导</a>
              <a href="#" class="footer-link">高等教育辅导</a>
              <a href="#" class="footer-link">音乐教育咨询</a>
            </div>
          </div>
        </div>
      </footer>
    </template>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import Register from '../components/Register.vue'

import { ElButton, ElCard } from 'element-plus'

const router = useRouter()

const currentPage = ref('home')
const activeTab = ref('employer')

// dropdown
const openDropdown = ref(null)

// 人才库：默认选中“市场专家”
const activeTalentCatKey = ref('marketing')

// 找工作：默认大类 & 默认高亮子项
const activeJobsCatKey = ref('web')
const activeJobsSubKey = ref('APP开发')

// 人才库
const talentMenu = ref({
  title: '人才库',
  leftCategories: [
    { key: 'developer', label: '开发者' },
    { key: 'creator', label: '创意者' },
    { key: 'marketing', label: '市场专家' },
    { key: 'sales', label: '销售专家' },
    { key: 'edu', label: '教育者' },
  ],
})

const talentMap = ref({
  developer: [
    { title: 'web开发', items: ['APP开发', '软件开发', '游戏开发', 'AI开发'] },
    { title: '视频剪辑', items: ['UX设计', 'UI设计', '品牌设计', 'Web设计'] },
    { title: '文案制作', items: ['网站运维', '翻译', '品牌管理', '营销策划'] },
    { title: '销售业务', items: ['学习辅导', '临考冲刺', '论文质量提升'] },
    { title: '初中教育辅导', items: ['高中教育辅导', '高等教育辅导', '音乐教育咨询'] },
  ],
  creator: [
    { title: '视频剪辑', items: ['剪辑', '特效', '调色', '字幕'] },
    { title: '设计', items: ['UI设计', '平面设计', '品牌设计', '插画'] },
    { title: '内容', items: ['文案', '脚本', '短视频策划', '直播运营'] },
  ],
  marketing: [
    { title: '初中教育辅导', items: ['数学', '语文', '英语', '物理', '化学'] },
    {
      title: '高中教育辅导',
      items: ['数学', '语文', { label: '英语', highlight: true }, '物理', '化学', '历史', '政治', '地理', '生物'],
    },
    { title: '高等教育辅导', items: ['学习辅导', '临考冲刺', '论文质量提升'] },
  ],
  sales: [
    { title: '销售业务', items: ['电销', '网销', '面销', '渠道拓展'] },
    { title: '客服', items: ['售前', '售后', '外呼', '社群'] },
  ],
  edu: [
    { title: '初中教育辅导', items: ['数学', '语文', '英语', '物理', '化学'] },
    { title: '高中教育辅导', items: ['数学', '语文', '英语', '物理', '化学', '历史', '政治', '地理', '生物'] },
    { title: '高等教育辅导', items: ['学习辅导', '临考冲刺', '论文质量提升'] },
  ],
})

// 找工作
const jobsMenu = ref({
  title: '找工作',
  leftCategories: [
    { key: 'web', label: 'web开发' },
    { key: 'video', label: '视频剪辑' },
    { key: 'copy', label: '文案制作' },
    { key: 'sales', label: '销售业务' },
    { key: 'edu', label: '教育辅导' },
  ],
})

const jobsMap = ref({
  web: { title: 'web开发', items: ['APP开发', '软件开发', '游戏开发', 'AI开发'] },
  video: {
    title: '视频剪辑',
    items: ['UX设计', 'UI设计', '品牌设计', 'Web设计', '家装设计', 'AI创作', '产品设计', '音乐', '化学', '生物'],
  },
  copy: { title: '文案制作', items: ['网站运维', '翻译', '品牌管理', '流量推广', '营销策划', 'SEO', '品牌运营'] },
  sales: { title: '销售业务', items: ['学习辅导', '临考冲刺', '论文质量提升', '论文质量提升'] },
  edu: { title: '初中教育辅导', items: ['高中教育辅导', '高等教育辅导', '音乐教育咨询'] },
})

const staticReviews = ref([
  { badge: '创意者', text: '"JobMatch平台帮助我快速找到了合适的设计师，项目进度非常快，沟通也很顺畅。”', name: '李先生', date: '2025-01-01', rating: 4.8 },
  { badge: '开发者', text: '"通过云链平台接到了很多优质项目，收入稳定，平台服务也很专业。强烈推荐给其他自由职业者！”', name: '王女士', date: '2025-01-05', rating: 4.9 },
  { badge: '市场专家', text: '"云链平台的匹配算法非常精准，帮我找到了最适合的营销人才，项目效果超出预期。”', name: '张总', date: '2025-01-10', rating: 4.7 },
  { badge: '教育者', text: '"作为一名教育工作者，在云链上找到了很多优质的教学项目，收入稳定且有保障。”', name: '刘老师', date: '2025-01-15', rating: 4.9 },
  { badge: '销售专家', text: '"平台的支付系统很安全，项目完成后能及时收到款项，让我可以安心工作。”', name: '陈先生', date: '2025-01-20', rating: 4.8 },
  { badge: '视频剪辑', text: '"在云链接了很多视频剪辑的单子，客户都很专业，合作愉快，强烈推荐！”', name: '小美', date: '2025-01-25', rating: 5.0 },
])

const services = ref([
  { icon: new URL('../assets/Frame(4).png', import.meta.url).href, name: '开发者' },
  { icon: new URL('../assets/Frame.png', import.meta.url).href, name: '创意者' },
  { icon: new URL('../assets/Frame(1).png', import.meta.url).href, name: '市场专家' },
  { icon: new URL('../assets/Frame(2).png', import.meta.url).href, name: '销售专家' },
  { icon: new URL('../assets/Frame(3).png', import.meta.url).href, name: '教育者' },
  { icon: new URL('../assets/Frame(4).png', import.meta.url).href, name: 'web开发' },
  { icon: new URL('../assets/Frame(5).png', import.meta.url).href, name: '视频剪辑' },
  { icon: new URL('../assets/Frame(6).png', import.meta.url).href, name: '文案制作' },
  { icon: new URL('../assets/Frame(7).png', import.meta.url).href, name: '销售业务' },
  { icon: new URL('../assets/Frame(7).png', import.meta.url).href, name: '教育辅导' },
])

const talentColumns = computed(() => {
  const cols = talentMap.value?.[activeTalentCatKey.value] || []
  return cols.map((c) => ({
    title: c.title,
    items: (c.items || []).map((i) => {
      if (typeof i === 'string') return { label: i, highlight: false }
      return { label: i.label, highlight: !!i.highlight }
    }),
  }))
})

const jobsColumns = computed(() => {
  const order = ['web', 'video', 'copy', 'sales', 'edu']
  const active = activeJobsCatKey.value
  const sorted = active && order.includes(active) ? [active, ...order.filter((k) => k !== active)] : order

  return sorted
    .map((key) => {
      const col = jobsMap.value?.[key]
      if (!col) return null
      return {
        key,
        title: col.title,
        items: (col.items || []).map((label) => ({
          label,
          highlight: label === activeJobsSubKey.value,
        })),
      }
    })
    .filter(Boolean)
})

function setTalentSub() {
  router.push('/talent')
}
function setJobsSub(label) {
  activeJobsSubKey.value = label
  router.push('/tasks')
}

function setJobsCategory(key) {
  activeJobsCatKey.value = key
  const first = jobsMap.value?.[key]?.items?.[0]
  activeJobsSubKey.value = first || ''
}

function toggleDropdown(type) {
  openDropdown.value = openDropdown.value === type ? null : type
  if (openDropdown.value === 'talent') activeTalentCatKey.value = 'marketing'
  if (openDropdown.value === 'jobs') {
    activeJobsCatKey.value = 'web'
    activeJobsSubKey.value = 'APP开发'
  }
}

function closeDropdown() {
  openDropdown.value = null
}
function setTalentCategory(key) {
  activeTalentCatKey.value = key
}

function onDocClick(e) {
  if (!openDropdown.value) return
  const header = document.querySelector('.header')
  if (header && header.contains(e.target)) return
  closeDropdown()
}

onMounted(() => {
  document.addEventListener('click', onDocClick, true)
})
onBeforeUnmount(() => {
  document.removeEventListener('click', onDocClick, true)
})
</script>

<style lang="scss">
/* Element Plus 兼容补丁（不改变视觉） */
.service-card,
.review-card {
  .el-card__body {
    padding: 0 !important;
    display: contents;
  }
}

/* ===========================
   ✅ 新增：process 滑块切换（覆盖效果）
   =========================== */
.process-switch {
  position: absolute;
  top: -110px;
  right: 80px;
}

.switch-pill {
  width: 360px;
    height: 40px;
    overflow: hidden; 
    // border: 2px solid #8D8C8C;
    border-radius: 80px 80px 80px 80px;
  background: #fff;
  position: relative;
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
}
/* 灰色外框（底层） */
.switch-pill::before {
  content: '';
  position: absolute;
  inset: 0;
  border: 2px solid #d3d3d3;
  border-radius: 999px;
  z-index: 1;                /* 在底下 */
  pointer-events: none;
}
/* 中间分割线（在底层） */
.switch-pill::after {
  // content: '';
  // position: absolute;
  // left: 50%;
  // top: 14px;
  // bottom: 14px;
  // width: 1px;
  // background: #d3d3d3;
  // transform: translateX(-0.5px);
  // z-index: 2;             
  // pointer-events: none;
}

/* 滑块（覆盖层）：默认在左，切换到右时平移 */
/* 绿色滑块：外扩覆盖灰框 */
.switch-slider {
  position: absolute;
  top: 0px;                 /* 关键：外扩一点盖住灰框 */
  bottom: 0px;
  left: 0px;
  width: calc(50%);    /* 左右都外扩 2px */
  border: 2px solid #4CAF50;
  border-radius: 999px;
  background: #fff;
  z-index: 5;                /* 关键：必须高于 ::before/::after */
  transition: transform 260ms ease;
  transform: translateX(0);
}

.switch-slider.right {
  transform: translateX(100%);
}

/* 两个按钮在滑块上方点击（z-index 更高），文字显示在滑块之上 */
.switch-btn {
  position: relative;
  z-index: 4;
  height: 100%;
  width: 100%;
  border: 0;
  background: transparent;
  cursor: pointer;

  font-size: 18px;  /* 图里字体很大 */
  color: #333333;
  letter-spacing: 2px;

  display: flex;
  align-items: center;
  justify-content: center;

  user-select: none;
}

.switch-btn.active {
  color: #4CAF50;
  z-index: 99;
}

/* 窄屏自适应 */
@media (max-width: 1100px) {
  .process-switch {
    right: 24px;
  }

  .switch-pill {
    width: min(860px, calc(100vw - 48px));
    height: 70px;
  }

  .switch-btn {
    font-size: 28px;
    letter-spacing: 1px;
  }
}


/* ElCard 默认结构会包一层 body，这里让你的 service-card/review-card 继续按 flex/布局工作 */
.service-card,
.review-card {
  .el-card__body {
    padding: 0 !important;
    display: contents;
  }
}

/* ElTabs 默认下划线等元素去掉，用你原来的 process-tab 视觉 */
.ep-tabs-reset {
  .el-tabs__header {
    border-bottom: none;
    margin: 0;
  }

  .el-tabs__nav-wrap::after {
    display: none;
  }

  .el-tabs__active-bar {
    display: none;
  }

  .el-tabs__item {
    padding: 0;
    height: auto;
    line-height: normal;
  }
}

/* ✅✅✅ 新增/覆盖：把 process-tabs 画成图里的胶囊分段按钮 */
.process-tabs.ep-tabs-reset {
  position: absolute;
  top: -110px;
  right: 80px;
  display: block;

  .el-tabs__header {
    margin: 0;
    border-bottom: 0;
  }

  .el-tabs__nav-wrap {
    margin: 0;
  }

  .el-tabs__nav {
    position: relative;
    display: flex;
    width: 640px;              /* 可按设计稿微调 */
    height: 72px;              /* 可按设计稿微调 */
    border: 2px solid #cfcfcf;  /* 外框灰色 */
    border-radius: 999px;
    background: #fff;
    overflow: hidden;
  }

  /* 中间分割线 */
  .el-tabs__nav::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 10px;
    bottom: 10px;
    width: 1px;
    background: #d8d8d8;
    transform: translateX(-0.5px);
    pointer-events: none;
  }

  /* 让每个 tab 平分 */
  .el-tabs__item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    /* 留出内边距，让激活态边框在内部 */
    margin: 6px !important;
    height: calc(100% - 12px) !important;

    border-radius: 999px;
    font-size: 28px;
    font-weight: 500;
    color: #2b2b2b;
    background: transparent;
    transition: all 0.2s ease;
  }

  .el-tabs__item:hover {
    color: #1f1f1f;
  }

  /* 选中态：绿色描边 + 绿色字 */
  .el-tabs__item.is-active {
    color: #4caf50;
    background: #fff;
    box-shadow: inset 0 0 0 2px #4caf50;
    z-index: 2;
  }
}

/* 窄屏适配，避免过宽 */
@media (max-width: 900px) {
  .process-tabs.ep-tabs-reset {
    right: 24px;

    .el-tabs__nav {
      width: 520px;
      max-width: calc(100vw - 48px);
      height: 60px;
    }

    .el-tabs__item {
      font-size: 22px;
    }
  }
}

/* ===========================
   下面：你的原 CSS（完整保留，未去重）
   =========================== */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Space Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  min-height: 100vh;
  margin: 0;
  padding: 0;
}

.app-container {
  min-height: 100vh;
  background-image: url('../assets/Frame 427320487.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* 以下样式保持不变，直接复用 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 80px;
  background: transparent;
  // max-width: 1600px;
  margin: 0 auto;
  position: relative;
  border: none;
  border-bottom: 1px solid #d0d0d0;
  box-shadow: none;
  z-index: 30;
  /* 让下拉层盖在内容上 */
}

.header::after {
  display: none;
}

.logo {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}

.logo-img {
  display: block;
}

.nav {
  display: flex;
  gap: 48px;
  /* position: absolute;
  left: 280px; */
}

.nav-link {
  color: #1a1a1a;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: color 0.3s;
  position: relative;
}

.nav-link:hover {
  color: #4ECDC4;
}

.nav-link-dropdown.is-open {
  color: #4CAF50;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 32px;
}

.action-link {
  color: #1a1a1a;
  font-size: 16px;
  cursor: pointer;
  transition: color 0.3s;
  font-weight: 500;
}

.action-link:hover {
  color: #4ECDC4;
}

.register-btn {
  background: #5CB85C;
  color: white;
  border: none;
  padding: 14px 32px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.register-btn:hover {
  background: #4CAF50;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(92, 184, 92, 0.3);
}

/* ========= 下拉菜单（新增） ========= */
.mega-dropdown {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 1px);
  background: #fff;
  border-top: 1px solid #efefef;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
}

.mega-panel {
  // max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 48px;
  /* padding-top: 59px; */
}

.mega-inner {
  // max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  padding: 0px 80px;
  display: grid;
  grid-template-columns: 328px 1fr;
  gap: 40px;
}

/* 人才库：左侧 */
.talent-left1 {
  background: #F5FFF5;
  padding-top: 37px;
}

.talent-left-title1 {
  font-weight: 500;
  font-size: 28px;
  color: #181818;
  padding: 0px 60px 49px;
}

.talent-left-list1 {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.talent-left-item1 {
  padding: 15px 60px;
  font-size: 16px;
  color: #181818;
  cursor: pointer;
}

.talent-left-item.active {
  background: #E0FFE2;
  color: #4CAF50;
  font-weight: bold;
}

/* 右侧列 */
.talent-right {
  padding: 48px 0;
  padding-left: 60px;
}

.talent-right .cols,
.jobs-cols {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 44px;
}

.jobs-inner {
  grid-template-columns: 250px 1fr;
  gap: 0;
  padding-top: 59px;
}

.jobs-left-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.jobs-left-item {
  padding: 15px 60px;
  font-size: 16px;
  color: #181818;
  cursor: pointer;
}

.jobs-left-item.active {
  background: #E0FFE2;
  color: #4CAF50;
  font-weight: bold;
}

.jobs-right {
  padding: 18px 0;
  padding-left: 60px;
}

/* 关键：右侧固定 5 列（符合示例图） */
.jobs-inner .jobs-cols {
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 44px;
}

.col-title {
  font-size: 16px;
  font-weight: 400;
  color: #181818;
  margin-bottom: 40px;
}

.col-items {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.col-item {
  font-size: 16px;
  color: #181818;
  cursor: pointer;
  padding: 8px 10px;
  border-radius: 6px;
}

.col-item:hover {
  background: #F2FFF4;
}

.col-item.highlight {
  background: #E0FFE2;
  color: #4CAF50;
  font-weight: 500;
}

/* 点击空白处关闭的遮罩 */
.dropdown-backdrop {
  position: fixed;
  inset: 0;
  background: transparent;
  z-index: 10;
  /* 小于 header 的 30，避免挡住下拉 */
}

/* 你原来的 main-content 等保持不变 */
.main-content {
  padding: 60px 80px;
  max-width: 1600px;
  margin: 0 auto;
}

/* --- 下面保持你原样式不变（我按你发来的内容原封不动保留） --- */

/* 响应式：窄屏下拉改两列/滚动（简单处理） */
@media (max-width: 1100px) {
  .mega-inner {
    padding: 18px 24px 26px;
    grid-template-columns: 1fr;
  }

  .talent-right .cols {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .jobs-inner .jobs-cols {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Space Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  min-height: 100vh;
  margin: 0;
  padding: 0;
}

.app-container {
  min-height: 100vh;
  background-image: url('../assets/Frame 427320487.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* 以下样式保持不变，直接复用 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 80px;
  background: transparent;
  // max-width: 1600px;
  margin: 0 auto;
  position: relative;
  border: none;
  border-bottom: 1px solid #d0d0d0;
  box-shadow: none;
}

.header::after {
  display: none;
}

.logo {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}

.logo-img {
  display: block;
}

.nav {
  display: flex;
  gap: 48px;
  /* position: absolute;
  left: 280px; */
}

.nav-link {
  color: #1a1a1a;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: color 0.3s;
  position: relative;
}

.nav-link:hover {
  color: #4ECDC4;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 32px;
}

.action-link {
  color: #1a1a1a;
  font-size: 16px;
  cursor: pointer;
  transition: color 0.3s;
  font-weight: 500;
}

.action-link:hover {
  color: #4ECDC4;
}

.register-btn {
  background: #5CB85C;
  color: white;
  border: none;
  padding: 14px 32px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.register-btn:hover {
  background: #4CAF50;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(92, 184, 92, 0.3);
}

.main-content {
  padding: 60px 80px;
  max-width: 1600px;
  margin: 0 auto;
}

.hero-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 100px;
  gap: 80px;
  min-height: 500px;
}

.hero-text {
  flex: 0 0 45%;
  max-width: 550px;
}

.hero-title {
  font-size: 58px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.15;
  margin-bottom: 28px;
  letter-spacing: -0.5px;
}

.hero-description {
  font-size: 17px;
  color: #5a5a5a;
  line-height: 1.7;
  margin-bottom: 36px;
}

.cta-button {
  background: #1a1a1a;
  color: white;
  border: none;
  padding: 18px 36px;
  border-radius: 10px;
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.cta-button:hover {
  background: #333;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
  max-width: 100%;
}

.service-card {
  background: white;
  border-radius: 20px;
  padding: 36px 28px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 18px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(128, 128, 128, 0.25);
  border: 1px solid rgba(200, 200, 200, 0.3);
  position: relative;
  overflow: hidden;
}

.service-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transition: left 0.5s;
}

.service-card:hover::before {
  left: 100%;
}

.service-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 20px 40px rgba(128, 128, 128, 0.4);
  border-color: rgba(78, 205, 196, 0.3);
}

.service-icon {
  width: 52px;
  height: 52px;
  object-fit: contain;
}

.service-name {
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
  text-align: left;
}

.about-wrapper {
  background: white;
  margin-top: 80px;
  padding: 100px 0;
  border-radius: 40px 40px 0 0;
  box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.05);
}

.about-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 80px;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 80px;
}

.about-content {
  flex: 0 0 45%;
}

.about-title {
  font-size: 42px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 32px;
  letter-spacing: -0.5px;
}

.about-text {
  font-size: 16px;
  color: #5a5a5a;
  line-height: 1.8;
  margin-bottom: 24px;
}

.about-logo {
  flex: 0 0 45%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.about-video {
  width: 100%;
  max-width: 500px;
  height: auto;
  border-radius: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  object-fit: cover;
}

.process-wrapper {
  background: white;
  padding: 150px 0 100px;
}

.process-section {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 80px;
  position: relative;
}

.process-tabs {
  position: absolute;
  top: -110px;
  right: 80px;
  display: flex;
  gap: 0;
  background: transparent;
}

.process-tab {
  width: 182px;
  height: 40px;
  border: 2px solid #D0D0D0;
  background: white;
  color: #999;
  font-family: 'Source Han Sans CN', sans-serif;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  white-space: nowrap;
}

.process-tab:first-child {
  border-radius: 80px;
  z-index: 1;
}

.process-tab:last-child {
  border-radius: 0 80px 80px 0;
  margin-left: -20px;
  padding-left: 20px;
  z-index: 0;
}

.process-tab.active {
  background: white;
  border-color: #4CAF50;
  color: #4CAF50;
  z-index: 3;
}

.process-steps {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  margin-top: 80px;
}

.process-step {
  background: white;
  border-radius: 20px;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 4px 16px rgba(128, 128, 128, 0.15);
  border: 1px solid rgba(200, 200, 200, 0.3);
  transition: all 0.3s;
}

.process-step:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 32px rgba(128, 128, 128, 0.25);
}

.step-image {
  width: 200px;
  height: 200px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.step-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
}

.usage-wrapper {
  background: white;
  padding: 80px 0 100px;
}

.usage-section {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 80px;
}

.usage-title {
  font-size: 42px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 16px;
  letter-spacing: -0.5px;
}

.usage-description {
  font-size: 16px;
  color: #5a5a5a;
  text-align: center;
  margin-bottom: 60px;
}

.usage-content {
  display: flex;
  gap: 40px;
  align-items: flex-start;
}

.usage-left {
  flex: 0 0 48%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.usage-step {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 28px 36px;
  background: #f5f5f5;
  border-radius: 20px;
  border: 2px solid #e8e8e8;
  transition: all 0.3s;
  cursor: pointer;
}

.usage-step.active {
  background: #f5f5f5;
  border-color: #5CB85C;
  box-shadow: 0 4px 12px rgba(92, 184, 92, 0.1);
}

.step-indicator {
  display: flex;
  align-items: center;
  gap: 16px;
}

.step-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #d0d0d0;
  flex-shrink: 0;
}

.step-dot.active {
  background: #5CB85C;
}

.step-label {
  font-size: 17px;
  font-weight: 500;
  color: #1a1a1a;
}

.step-button {
  padding: 12px 28px;
  border: none;
  border-radius: 10px;
  background: #e8e8e8;
  color: #999;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.step-button.active {
  background: #5CB85C;
  color: white;
}

.view-more {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s;
}

.view-more-text {
  font-size: 16px;
  font-weight: 600;
  color: #5CB85C;
}

.usage-right {
  flex: 0 0 48%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
}

.preview-image {
  width: 110%;
  max-width: 110%;
  height: auto;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  margin-left: -2%;
  object-fit: cover;
  object-position: left center;
}

.reviews-wrapper {
  background: white;
  padding: 50px 0 60px;
}

.reviews-section {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 80px;
}

.reviews-title {
  font-size: 36px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 12px;
  letter-spacing: -0.5px;
}

.reviews-description {
  font-size: 15px;
  color: #5a5a5a;
  text-align: center;
  margin-bottom: 30px;
}

.reviews-container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 20px;
}

.review-card {
  width: 100%;
  height: 200px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 8px 16px 0px rgba(9, 58, 11, 0.1);
  border-radius: 12px;
  border: 1px solid rgba(230, 230, 230, 0.5);
  border-left: 6px solid;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: all 0.3s;
  position: relative;
}

.review-badge {
  background: #FFF4E6;
  color: #F59E0B;
  padding: 4px 10px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 600;
}

.review-text {
  font-size: 12px;
  color: #4a4a4a;
  line-height: 1.4;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.review-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;
  margin-top: auto;
}

.reviewer-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.reviewer-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.reviewer-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.reviewer-name {
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
}

.reviewer-date {
  font-size: 11px;
  color: #999;
}

.review-rating {
  display: flex;
  align-items: center;
  gap: 3px;
}

.star {
  color: #FFC107;
  font-size: 16px;
}

.rating-score {
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
}

.why-choose-wrapper {
  background: white;
  padding: 80px 0 100px;
}

.why-choose-section {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 80px;
}

.why-choose-title {
  font-size: 42px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 16px;
  letter-spacing: -0.5px;
}

.why-choose-description {
  font-size: 16px;
  color: #5a5a5a;
  text-align: center;
  margin-bottom: 60px;
}

.comparison-image {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.comparison-img {
  width: 100%;
  max-width: 1200px;
  height: auto;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.footer {
  background: #1a1a1a;
  color: white;
  padding: 60px 0 40px;
}

.footer-content {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 80px;
}

.footer-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 60px;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-logo-section {
  display: flex;
  align-items: center;
}

.footer-logo {
  height: 40px;
  width: auto;
}

.footer-join-btn {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 12px 32px;
  border-radius: 25px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 60px;
}

.footer-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer-column-title {
  font-size: 16px;
  font-weight: 600;
  color: white;
  margin-bottom: 8px;
}

.footer-link {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: color 0.3s;
}

.footer-link:hover {
  color: white;
}


</style>